
/**
 * This file is auto-generated. Do not modify directly.
 */

/* tslint:disable */
export type DayOfWeekNames = {
  sun: string;
  mon: string;
  tue: string;
  wed: string;
  thu: string;
  fri: string;
  sat: string;
};

export type LocaleDataType = {
  firstDayOfWeek: keyof DayOfWeekNames;
  prefer24HourTimeCycle: boolean;
  abbreviatedDayNames: DayOfWeekNames;
  narrowDayNames: DayOfWeekNames;
  shortDayNames: DayOfWeekNames;
  wideDayNames: DayOfWeekNames;
};

export type LocalizeFormat = {
  localeData: LocaleDataType,
  formatRelativeTime: any,
  formatBestFitRelativeTime: any,
  formatUnit: any,
  formatDate: any,
  formatNumber: any
  parseDate: any,
  parseNumber: any,
  currentLocale: string, // FormatLocale
};

export type LocalizeMessage = {
  currentLocale: string; // MessageLocale;
};

interface Localize {
  msg: any, format: LocalizeFormat, message: LocalizeMessage
}
declare const CustomLocalizeNamespace: string;

declare const process: {
  release?: {
    name?: string
  }
};

/* istanbul ignore next */
function getLocalize() {
  let globalContainer;
  if (typeof process !== 'undefined' && typeof process.release !== 'undefined' && process.release.name === 'node') {
    globalContainer = global;
  } else {
    //@ts-ignore
    globalContainer = window;
  }

  let localizeNamespace = globalContainer as any;

  if (typeof CustomLocalizeNamespace === 'string') {
    localizeNamespace = (globalContainer as any)[CustomLocalizeNamespace];
  }

  if (typeof localizeNamespace.Localize === 'undefined') {
    throw Error('The messages.<locale>.js file has not been loaded');
  }

  return localizeNamespace.Localize as Localize;
};

/* istanbul ignore next */
export let getLocalizeFormat = () => {
  const localize = getLocalize();
  if (localize.format === undefined) {
    throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
  }
  return localize.format;
};

/* istanbul ignore next */
export let getCurrentMessageLocale = () => {
  const localize = getLocalize();
  if (localize.message.currentLocale === undefined) {
    throw Error('The localize.message.currentLocale has not been set');
  }
  return localize.message.currentLocale;
};


/* istanbul ignore next */
export const LocaleData = { get: () => getLocalizeFormat().localeData };

/* istanbul ignore next */
export const CurrentMessageLocale = { get: () => getCurrentMessageLocale() };
const t = (k: string, a?: any): string => getLocalize().msg.formatMessage(k, a);
export const Messages = {
  searchMicroviewErrorHeader: (a: {MICROVIEW_NAME: string}) => t('@tableau__microview/searchMicroviewErrorHeader', a),
  searchMicroviewErrorMessage: () => t('@tableau__microview/searchMicroviewErrorMessage'),
};
